module.exports = __webpack_public_path__ + "img/20191128170606388.cc828e61.jpg";